import { type Html, html, View } from 'rune-ts';
import {
  ProductBadgeColorVariants,
  ProductBadgeShape,
  ProductBadgeStyleHelper,
} from './ProductBadgeStyleHelper';
import base_klass from './styles/ProductBadgeBase.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { ProductBadgeOption } from '@services/MarppleShop/features/ProductBadge/type';

export type ProductBadgeBaseData<T = unknown> = {
  value: T;
  option: ProductBadgeOption;

  /**
   * @remarks 일단 받자
   */
  server_timestamp: number;
};

export abstract class ProductBadgeBase<T = unknown> extends View<ProductBadgeBaseData<T>> {
  protected label?: string;

  constructor(data: ProductBadgeBaseData<T>) {
    super(data);
    this.setLabel();
  }

  override template() {
    const baseKlass = ProductBadgeStyleHelper.getBaseKlass();
    const labelKlass = ProductBadgeStyleHelper.getLabelKlass();
    const colorKlass = ProductBadgeStyleHelper.getColorKlass(this.colorVariant());
    const shapeKlass = ProductBadgeStyleHelper.getShapeKlass(this.shape()) || '';
    const sizeKlass = ProductBadgeStyleHelper.getSizeKlass(this.data.option.size);
    const typoKlass = this.getTypo() || '';
    const hiddenKlass = this.getHiddenKlass();

    const iconKlass = ProductBadgeStyleHelper.getIconKlass(this.data.option.size);

    return html`<span
      class="${classes([
        baseKlass,
        colorKlass,
        shapeKlass,
        sizeKlass,
        typoKlass,
        hiddenKlass,
        this.data.option.klass,
      ])}"
    >
      ${this.getIcon() ? html`<span class="${iconKlass}">${this.getIcon()}</span>` : ''}
      ${!this.data.option.hide_label ? html`<span class="${labelKlass}">${this.label}</span>` : ''}
    </span>`;
  }

  refreshBadge() {
    this.setLabel();
    this.redraw();
  }

  protected abstract setLabel(): void;
  abstract isTimerNeeded(): boolean;
  abstract getIcon(): Html | string | null;
  abstract getTypo(): string | undefined;
  abstract colorVariant(): ProductBadgeColorVariants;
  abstract shape(): ProductBadgeShape;

  public isVisible(): boolean {
    return true;
  }

  private getHiddenKlass(): string {
    return this.isVisible() ? '' : base_klass.hidden;
  }

  public setValue(value: T) {
    this.data.value = value;
    this.refreshBadge();
  }
}
